import axios from 'axios';

export default {
  loadDigitalResources () {
    return new Promise(resolve => {
      axios.get(`https://datahub-v2-s3.arlingtonva.us/Uploads/AutomatedJobs/DigitalResources.json?&timestamp=${new Date().getTime()}`).then((result) => {
        let data = result.data
        data.map(r => {
          if (r['Phone Number']) {
            r['Phone Number'] = r['Phone Number'].toString()
            if (r['Phone Number'].indexOf(',')) {
              var h = r['Phone Number'].split(',')
              if (h.length > 1) {
                h = h.map(p => this.formatPhoneNumber(p.replace(/(\r\n|\n|\r)/gm, '')));
                if (h) {
                  r['Phone Number'] = h.join(', ')
                }
              } else {
                r['Phone Number'] = this.formatPhoneNumber(r['Phone Number'])
              }
            } else {
              r['Phone Number'] = this.formatPhoneNumber(r['Phone Number'])
            }
          }
          if (r['Hours'] && r['Hours'] !== 'N/A' && r['Days of Operation'] && r['Days of Operation'] !== 'N/A') {
            r['Hours'] = r['Hours'].split(',')
            r['Days of Operation'] = r['Days of Operation'].split(',')
          }
          r.lat = parseFloat(r.Lat)
          r.lng = parseFloat(r.Lng)
          if (r['Reservation Requirements'] != null && r['Reservation Requirements'] !== 'N/A') {
            r['Reservation Requirements'] = '<span>' + r['Reservation Requirements'] + '</span>'
          }
          if (r['Notes/comments'] != null && r['Notes/comments'] !== 'N/A') {
            r['Notes/comments'] = '<span>' + r['Notes/comments'] + '</span>'
          }
        })
        data.sort(function (a, b) {
          var nameA = a.Facility.toUpperCase(); // ignore upper and lowercase
          var nameB = b.Facility.toUpperCase(); // ignore upper and lowercase
          if (nameA < nameB) {
            return -1;
          }
          if (nameA > nameB) {
            return 1;
          }
          return 0;
        });
        resolve(data);
      });
    })
  },
  formatPhoneNumber (phoneNumberString) {
    var cleaned = ('' + phoneNumberString).replace(/\D/g, '')
    var match = cleaned.match(/^(1|)?(\d{3})(\d{3})(\d{4})$/)
    if (match) {
      var intlCode = (match[1] ? '+1 ' : '')
      return [intlCode, '(', match[2], ') ', match[3], '-', match[4]].join('')
    }
    return null
  }
}



// WEBPACK FOOTER //
// ./src/components/digitalResources/digitalResources.service.js